/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_StartInputs */

const en_follow_start = /** @type {(inputs: Follow_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow`)
};

/**
* | output |
* | --- |
* | "Follow" |
*
* @param {Follow_StartInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const follow_start = /** @type {((inputs?: Follow_StartInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_StartInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_follow_start(inputs)
});